import { useQuery } from '@tanstack/react-query';
import { supabase } from '@/integrations/supabase/client';

export interface VitalRange {
  id: string;
  patient_id: string;
  vital_type: string;
  min_value: number | null;
  max_value: number | null;
  min_value_secondary: number | null;
  max_value_secondary: number | null;
  unit: string | null;
  created_by: string | null;
  created_at: string;
  updated_at: string;
}

export function usePatientVitalRanges(patientId: string | undefined) {
  const query = useQuery({
    queryKey: ['patient-vital-ranges', patientId],
    queryFn: async () => {
      if (!patientId) return [];
      const { data, error } = await supabase
        .from('patient_vital_ranges')
        .select('*')
        .eq('patient_id', patientId);

      if (error) throw error;
      return (data || []) as VitalRange[];
    },
    enabled: !!patientId
  });

  const getRangeForVitalType = (vitalType: string | null | undefined): VitalRange | undefined => {
    if (!vitalType || !query.data) return undefined;
    return query.data.find(r => r.vital_type === vitalType);
  };

  return {
    ranges: query.data || [],
    isLoading: query.isLoading,
    refetch: query.refetch,
    getRangeForVitalType
  };
}
